"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconCostUi = function IconCostUi(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M16 5.5C16 6.328 12.866 7 9 7s-7-.672-7-1.5S5.134 4 9 4s7 .672 7 1.5M2 7v2c0 .828 3.134 1.5 7 1.5l.255-.001a7 7 0 0 1 2.317-2.103C10.776 8.463 9.908 8.5 9 8.5c-3.866 0-7-.672-7-1.5m6.069 8.487c.1.71.307 1.386.604 2.011C4.959 17.462 2 16.805 2 16v-2c0 .76 2.643 1.39 6.069 1.487m.392-3.491a7 7 0 0 0-.442 1.99C4.617 13.882 2 13.256 2 12.5v-2c0 .79 2.847 1.437 6.461 1.496M16 21a6 6 0 1 0 0-12 6 6 0 0 0 0 12",
    clipRule: "evenodd"
  })));
};

export { IconCostUi, IconCostUi as default };
